/* ------------------------------------------------------------------
   PuraDorse — options payantes du tiroir de panier
   (Expedition prioritaire, Garantie Serenite)

   Ce fichier existe pour une raison precise : le gestionnaire de clic
   etait auparavant dans un <script> a l'interieur de
   snippets/pd-cart-extras.liquid. Or ce snippet n'est rendu que
   lorsque le panier n'est PAS vide, et le tiroir est ensuite
   rafraichi par injection de HTML (DOMParser + replaceWith).

   Un <script> insere de cette facon n'est jamais execute par le
   navigateur. Resultat : un client arrivant avec un panier vide —
   c'est-a-dire tout le monde — voyait les deux options s'afficher
   mais aucun clic n'avait d'effet.

   En le chargeant comme asset depuis snippets/stylesheets.liquid, il
   s'execute une fois par page, avant tout rafraichissement du tiroir.
   Ne pas le remettre dans le snippet.

   La liaison se fait par delegation sur document : les boutons sont
   detruits et recrees a chaque rendu serveur du tiroir, on ne peut
   donc pas les ecouter individuellement.
   ------------------------------------------------------------------ */
(function () {
  if (window.pdAddonsReady) return;
  window.pdAddonsReady = true;

  document.addEventListener('click', function (event) {
    var el = event.target.closest ? event.target.closest('[data-pd-addon]') : null;
    if (!el) return;
    event.preventDefault();

    var id = parseInt(el.getAttribute('data-pd-addon'), 10);
    if (!id || el.dataset.pdBusy === '1') return;

    var isOn = el.getAttribute('data-pd-addon-state') === 'on';
    el.dataset.pdBusy = '1';
    el.setAttribute('aria-busy', 'true');

    var settle = function () {
      el.dataset.pdBusy = '';
      el.removeAttribute('aria-busy');
    };
    var failed = function () {
      settle();
      window.alert("L'opération a échoué. Merci de réessayer.");
    };
    var refresh = function () {
      if (window.pdCart && window.pdCart.refreshDrawer) return window.pdCart.refreshDrawer();
      window.location.reload();
      return Promise.resolve();
    };

    if (isOn) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: 0 })
      })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(refresh)
        .then(settle)
        .catch(failed);
    } else if (window.pdCart && window.pdCart.add) {
      window.pdCart.add([{ id: id, quantity: 1 }]).then(settle).catch(failed);
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(refresh)
        .then(settle)
        .catch(failed);
    }
  });
})();
